export const WORKERS_COMP_TYPES = {
  REQUIRED: {display: 'Required', value: 'Required', showOrder: 0, def: true},
  EXEMPT: {display: 'Exempt', value: 'Exempt', showOrder: 1, def: false},
};
